import * as React from 'react';
import useHome from '../hooks/useHome';
const isCategoriesFunction = (arg) => {
    return typeof arg === 'function';
};
function returnChild(children, data) {
    return React.isValidElement(children)
        ? { children }
        : isCategoriesFunction(children)
            ? children(data)
            : null;
}
/**
 * Group provides a way to access the categories data via a render prop.
 * */
export const Group = ({ children }) => {
    const home = useHome();
    if (!home || !home.categories)
        return null;
    return React.createElement(React.Fragment, null, returnChild(children, home.categories));
};
Group.displayName = 'Cateogies.Group';
//# sourceMappingURL=categoriesGroup.js.map